import React from 'react'
import { string } from 'prop-types'

import Container from 'components/atoms/Container'
import Typography from 'components/atoms/Typography'

import config from 'config'

const { assets_url: assetsUrl } = config

const FacultySchoolIdentity = ({ logo, schoolName, facultyName }) => (
  <div className="faculty-school-identity">
    <Container>
      <div className="faculty-school-identity__wrapper">
        {
          logo && (
            <div className="faculty-school-identity__logo">
              <img src={logo} alt={`${facultyName} di ${schoolName}`}/>
            </div>
          )
        }
        <div className="faculty-school-identity__name">
          <Typography component="p" variant="body" className="faculty-school-identity__sch-name">
            {schoolName}
          </Typography>
          <Typography component="h1" variant="headline" className="faculty-school-identity__faculty-name" fontWeight="bold">
            {facultyName}
          </Typography>
        </div>
      </div>
    </Container>
    <style jsx>
      {`
        .faculty-school-identity {
          background-color: #e3ecf5;
          padding: 40px;
          background-image: url('${assetsUrl}/assets/img/building-low.jpg');
          background-size: cover;
          background-repeat: no-repeat;
          &__wrapper {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
          }
          &__logo {
            width: 80px;
            height: 80px;
            padding: 8px;
            background-color: #fff;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 24px;
            img {
              max-width: 100%;
              max-height: 100%;
              border-radius: 8px;
            }
          }
          &__name {
            @media screen and (max-width: 768px) {
              margin-top: 1em;
            }
          }
          :global(&__faculty-name) {
            color: #0c2846;
            @media screen and (min-width: 768px) {
              font-size: 24px !important;
            }
          }
        }
      `}
    </style>
  </div>
)

FacultySchoolIdentity.propTypes = {
  logo: string,
  schoolName: string,
  facultyName: string,
}

export default FacultySchoolIdentity
